/**
 * @generated SignedSource<<698fd944f178dec47aef3d3772335fbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type areaBackgroundRuleEditor_AreaBackgroundRulesListQuery$variables = Record<PropertyKey, never>;
export type areaBackgroundRuleEditor_AreaBackgroundRulesListQuery$data = {
  readonly areaBackgroundRules: ReadonlyArray<{
    readonly areaBackgroundRuleID: number;
    readonly id: string;
  }>;
};
export type areaBackgroundRuleEditor_AreaBackgroundRulesListQuery = {
  response: areaBackgroundRuleEditor_AreaBackgroundRulesListQuery$data;
  variables: areaBackgroundRuleEditor_AreaBackgroundRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AreaBackgroundRuleTool",
    "kind": "LinkedField",
    "name": "areaBackgroundRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "areaBackgroundRuleID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "areaBackgroundRuleEditor_AreaBackgroundRulesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "areaBackgroundRuleEditor_AreaBackgroundRulesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "51e0d478888e1d7d0a75126267b582aa",
    "id": null,
    "metadata": {},
    "name": "areaBackgroundRuleEditor_AreaBackgroundRulesListQuery",
    "operationKind": "query",
    "text": "query areaBackgroundRuleEditor_AreaBackgroundRulesListQuery {\n  areaBackgroundRules {\n    id\n    areaBackgroundRuleID\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a98f170e1b0bef68c76176fd6faa73b";

export default node;
